import { CSS_PROPERTY } from '../../enums';
import { getCssBasedOnRtl } from '../../styles';
import styled from 'styled-components';

export const Container = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  margin: 0;
  outline: none;
  padding: ${({ theme }) => theme.spacing.base.xxs} 0 0;
  text-decoration: none;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.sm)};
  &:hover {
    text-decoration: underline;
  }
  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const Icon = styled.i`
  display: flex;
  height: 16px;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xxs)};
  width: 16px;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.ui.links.fontColor};
  font-size: ${({ theme }) => theme.typography.size.small};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  text-decoration: none;
`;
